import { Text, Tooltip, VStack } from "@chakra-ui/react";
import { formatDate } from "@syla/shared/helpers/formatting";
import { assertNever } from "@syla/shared/types/helpers/errors";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import { getSubscriptionState } from "@syla/shared/types/subscriptions/getSubscriptionState";
import {
  RenewalAction,
  SubscriptionState,
} from "@syla/shared/types/subscriptions/subscriptionState";
import { format } from "date-fns";
import { enAU } from "date-fns/locale";
import React, { ReactElement } from "react";
import { PlanStatusTag } from "../accountSettings/subscription/PlanStatusTag";

interface RenewalDateProps {
  subscription: SubscriptionWithPlansAndAccess | undefined;
}

export const RenewalDateCell = ({ subscription }: RenewalDateProps) => {
  if (!subscription) {
    return (
      <VStack alignItems="flex-start">
        <Text>N/A</Text>
      </VStack>
    );
  }

  const subscriptionState = getSubscriptionState(subscription);

  const tooltipElement = getTooltip(subscriptionState);

  return (
    <VStack alignItems="flex-start">
      {tooltipElement}
      <PlanStatusTag status={subscriptionState.status} />
    </VStack>
  );
};

function getTooltip(state: SubscriptionState): ReactElement | null {
  const renewal = state.renewal;

  // if the plan has already expired, we don't show the renewal date
  if (renewal === RenewalAction.None) {
    return null;
  }

  const displayDate = formatDate(state.periodEnd);
  const tooltipDate = format(state.periodEnd, "P", {
    locale: enAU,
  });

  if (renewal === RenewalAction.Renew) {
    const tooltip = `Renews on ${displayDate}`;
    return (
      <Tooltip label={tooltip}>
        <Text>{tooltipDate}</Text>
      </Tooltip>
    );
  }

  if (renewal === RenewalAction.Downgrade) {
    const tooltip = `Downgrades and renews on ${displayDate}`;
    return (
      <Tooltip label={tooltip}>
        <Text>{tooltipDate}</Text>
      </Tooltip>
    );
  }

  if (renewal === RenewalAction.Cancel) {
    const tooltip = `Expires on ${displayDate}`;
    return (
      <Tooltip label={tooltip}>
        <Text>Expires {tooltipDate}</Text>
      </Tooltip>
    );
  }

  assertNever(renewal);
}
